var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDefaultInfluencerUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 51,
    viewBox: "0 0 51 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 25.2979,
    cy: 25.7854,
    r: 25,
    fill: "#CDD9E7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.2979 39.7854H35.2979V34.7854C35.2957 32.9295 34.5576 31.1503 33.2453 29.838C31.933 28.5257 30.1537 27.7875 28.2979 27.7854H22.2979C20.442 27.7875 18.6627 28.5257 17.3504 29.838C16.0381 31.1503 15.3 32.9295 15.2979 34.7854V39.7854ZM18.2979 18.7854C18.2979 20.1699 18.7084 21.5232 19.4776 22.6744C20.2467 23.8255 21.34 24.7227 22.6191 25.2526C23.8981 25.7824 25.3056 25.921 26.6635 25.6509C28.0214 25.3808 29.2686 24.7141 30.2476 23.7351C31.2266 22.7562 31.8933 21.5089 32.1633 20.151C32.4334 18.7932 32.2948 17.3857 31.765 16.1066C31.2352 14.8275 30.338 13.7343 29.1868 12.9651C28.0357 12.1959 26.6823 11.7854 25.2979 11.7854C23.4413 11.7854 21.6609 12.5229 20.3481 13.8357C19.0353 15.1484 18.2979 16.9289 18.2979 18.7854Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefaultInfluencerUser);
export default __webpack_public_path__ + "static/media/default-influencer-user.1083aba8795d103ec4b2e23076b54d23.svg";
export { ForwardRef as ReactComponent };